import {between, maxValue, minValue, numeric, required} from 'vuelidate/lib/validators';
import {EsalCalculationMethods} from '@/modules/design/interfaces/shared';
import {IAcOverlayDesignImperial, StructuralEvaluationMethods} from '@/modules/design/interfaces/acOverlay';
import {UnitSystem} from '@/interfaces/units';

export const createAcOverlayValidations = (scenario: IAcOverlayDesignImperial, unitSystem: UnitSystem = UnitSystem.Imperial) => {
  console.log(scenario.existingLayers);
  const validationObject = {
    scenarioImperial: {
      // Page 1
      name: {
        required,
      },
      completionYear: {
        minValue: minValue(new Date(Date.now()).getFullYear() - 100),
        maxValue:
          maxValue(new Date(Date.now()).getFullYear() + 100),
      },
      roadwayClassification: {
        required,
      },

      state: {
        required,
      },

      // Page 2
      existingLayerCoeff: {
        required,
        minValue: minValue(0),
      },
      overlayLayerMinimumThickness_in: {
        required,
        minValue: minValue(0),
      },
      subgradeModulus_psi: {
        required,
        minValue: minValue(0),
      },
      existingLayers: (function () {
        // Create a validation for each available layer
        const layerMap: { [index: number]: any } = {};
        scenario.existingLayers.forEach((layer, i) => {
          if (layer.id) {
            layerMap[i] = {
              // layerCoefficient: {
              //   required,
              //   minValue: minValue(0),
              // },
              // drainageCoefficient: {
              //   required,
              //   minValue: minValue(0),
              // },
              type: {
                required,
              },
              thickness_in: {
                required,
                minValue: minValue(0),
              },
            };
          }
        });

        return layerMap;
      }()),

      // Page 3
      designPeriod_years: {
        required,
        numeric,
        minValue: minValue(0),
      },
      reliabilityLevel: {
        required,
      },
      standardError: {
        required,
        between: between(0, 1),
      },
      initialServiceability: {
        required,
        between: between(0, 5),
      },
      terminalServiceability: {
        required,
        between: between(0, 5),
      },


      // Page 4
      coresTaken: {
        required,
      },

      millRemoveDistressed: {
        required,
      },

      // Page 5
      initialTraffic: {
        required,
        minValue: minValue(0),
      },
      loadEquivalencyFactor: {
        required,
        minValue: minValue(0),
      },
      esals: {
        required,
        minValue: minValue(0),
      },
      trafficGrowthRate: {
        required,
      },
      esalGrowthRate: {
        required,
      },
      totalDesignEsals: {
        required,
        minValue: minValue(0),
      },
      loadDiameter_in: {
        required,
        minValue: minValue(0),
      },

    },

    /*
    Top level validations - not on model directly
     */


    // Page 2

    // layerMapForValidation: function () {
    //
    //   // Get available layers
    //   const layers: { [index: number]: IAcOverlayLayerImperial } = {};
    //   scenario.existingLayers.forEach(layer => {
    //     if (layer.id) {
    //       layers[layer.id] = layer
    //     }
    //   });
    //
    //   // Create a validation for each available layer
    //   const layerMap: { [index: number]: any } = {};
    //   Object.values(layers).forEach((layer) => {
    //     if (layer.id) {
    //       layerMap[layer.id] = {
    //         thickness_in: {
    //           required,
    //           minValue: minValue(0)
    //         }
    //       }
    //     }
    //   });
    //
    //   return layerMap
    //
    // }(),

    numLayers: {
      minValue: minValue(1),
    },

    deltaServiceability: {
      between: between(0, 5),
    },


    // Page 3
    aadtGroup: [
      'scenarioImperial.initialTraffic',
      'scenarioImperial.loadEquivalencyFactor',
      'scenarioImperial.esals',
      'scenarioImperial.trafficGrowthRate',
      'scenarioImperial.esalGrowthRate',
      'scenarioImperial.totalDesignEsals',
    ],
    annualEsalGroup: [
      'scenarioImperial.esals',
      'scenarioImperial.esalGrowthRate',
      'scenarioImperial.totalDesignEsals',
    ],
    designEsalGroup: [
      'scenarioImperial.totalDesignEsals',
    ],


    1: [
      'scenarioImperial.name',
      'scenarioImperial.completionYear',
      'scenarioImperial.roadwayClassification',
      'scenarioImperial.state',
    ],
    2: [
      // 'layerMapForValidation',
      'scenarioImperial.existingLayers',
      'scenarioImperial.existingLayerCoeff',
      'scenarioImperial.overlayLayerMinimumThickness_in',
      'scenarioImperial.subgradeModulus_psi',
      'numLayers',
    ],
    3: [
      'scenarioImperial.designPeriod_years',
      'scenarioImperial.reliabilityLevel',
      'scenarioImperial.standardError',
      'scenarioImperial.initialServiceability',
      'scenarioImperial.terminalServiceability',
      'deltaServiceability',
    ],

    4: [
      'scenarioImperial.coresTaken',
      'scenarioImperial.millRemoveDistressed',
    ],

    5: (function () {
      // Validate based on method of calculation and whether or not it's porous (extra param)

      if (scenario.esalCalculatedFrom === EsalCalculationMethods.aadt) {
        return [
          'scenarioImperial.initialTraffic',
          'scenarioImperial.loadEquivalencyFactor',
          'scenarioImperial.esals',
          'scenarioImperial.trafficGrowthRate',
          'scenarioImperial.esalGrowthRate',
          'scenarioImperial.totalDesignEsals',
        ];
      }
      if (scenario.esalCalculatedFrom === EsalCalculationMethods.annual) {
        return [
          'scenarioImperial.esals',
          'scenarioImperial.esalGrowthRate',
          'scenarioImperial.totalDesignEsals',
        ];
      }
      return [
        'scenarioImperial.totalDesignEsals',
      ];
    }()),

    6: [
      '1',
      '2',
      '3',
      '4',
      '5',
    ],

    // aadtGroupPorous: [
    //   'scenario.initialTraffic',
    //   'scenario.loadEquivalencyFactor',
    //   'scenario.esals',
    //   'scenario.trafficGrowthRate',
    //   'scenario.esalGrowthRate',
    //   'scenario.totalDesignEsals',
    //   'scenario.loadDiameter_in'
    // ],
    // annualEsalGroupPorous: [
    //   'scenario.esals',
    //   'scenario.esalGrowthRate',
    //   'scenario.totalDesignEsals',
    //   'scenario.loadDiameter_in'
    // ],
    // designEsalGroupPorous: [
    //   'scenario.totalDesignEsals',
    //   'scenario.loadDiameter_in'
    // ],

  };


  //
  // Validators for items shared by both evaluation methods
  //

  /*

  The display layer uses the existence of these validators to control display of the inputs.

   */

  if (scenario.millRemoveDistressed === true) {
    // @ts-ignore
    validationObject.scenarioImperial.removeDepth_in = {
      required,
      minValue: minValue(0),
    };

    if (scenario.structuralEvaluationMethod === StructuralEvaluationMethods.testing) {
      // @ts-ignore
      validationObject.scenarioImperial.estimatedStructuralCoefficient = {
        required,
        minValue: minValue(Number((unitSystem === UnitSystem.Imperial ? 0.05 : 0.05 / 2.54).toPrecision(3))),
        maxValue: maxValue(Number((unitSystem === UnitSystem.Imperial ? 0.5 : 0.5 / 2.54).toPrecision(3))),
      };
    }
  }

  //
  // If cores taken, add validators
  //
  if (scenario.coresTaken === true) {
    const coreValidators: any = {
      crackCoresTaken: {
        required,
      },
      stripping: {
        required,
      },
    };

    //
    // Crack Cores
    //
    if (scenario.crackCoresTaken === true) {
      // If crack cores, which type of cracks?
      coreValidators.topDownCracking = {
        required,
      };
      // If top down only, how deep?
      if (scenario.topDownCracking === 'Top-Down Only') {
        coreValidators.crackDepth_in = {
          required,
          minValue: minValue(0),
        };
      }
    }

    //
    // Stripping
    //
    if (scenario.stripping === true) {
      coreValidators.distressDepth_in = {
        required,
        minValue: minValue(0),
      };
    }

    Object.assign(validationObject.scenarioImperial, coreValidators);
    validationObject[4].push(...Object.keys(coreValidators).map((K) => `scenarioImperial.${K}`));
  }

  if (scenario.structuralEvaluationMethod === StructuralEvaluationMethods.survey) {
    const surveyValidators = {
      alligatorLow: {
        required,
      },
      alligatorMed: {
        required,
      },
      alligatorHigh: {
        required,
      },
      transverseLow: {
        required,
      },
      transverseMed: {
        required,
      },
      transverseHigh: {
        required,
      },
    };
    Object.assign(validationObject.scenarioImperial, surveyValidators);
    validationObject[4].push(...Object.keys(surveyValidators).map((K) => `scenarioImperial.${K}`));
  } else if (scenario.structuralEvaluationMethod === StructuralEvaluationMethods.testing) {
    const testingValidators = {
      combinedLayerStiffness: {
        required,
        minValue: minValue(0),
      },
      designSubgradeModulus_psi: {
        required,
        minValue: minValue(0.0),
      },
    };

    validationObject[4].push(...Object.keys(testingValidators).map((K) => `scenarioImperial.${K}`));

    Object.assign(validationObject.scenarioImperial, testingValidators);
  }
  return validationObject;
};
